<template>
  <div class="col-md-12 col-xs-10 ml30 mt10">
    <template v-if="!registerLinkLoading && !ipayLoading">
      <template v-if="defaultCard">
        <div class="col-md-6 credit-card p20 mb10 mx5 relative">
          <div class="flex">
            <div class="user-image">
              <img src="/assets/personal-details.svg" alt="Personal details" width="22" height="22" loading="lazy" fetchpriority="auto">
            </div>
            <div class="user-full-name">
              {{ defaultCard.details.card_alias }}
            </div>
          </div>
          <div class="number-cart mt15 col-md-12">{{ defaultCard.details.mask }}</div>
          <div class="col-md-12 col-xs-12">
            <div class="mt10 start-md start-xs">
              <span class="cl-bg-tertiary">{{ $t('Date') }}:</span>
              <span v-if="defaultCard.is_active">{{ $t('Active') }}</span>
              <span v-else>{{ $t('Not active') }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xs-12 mt25 change-card">
          <button-full class="button-change-card change" @click.native="changeCard">{{ $t('Change card') }}</button-full>
        </div>
      </template>
      <div class="col-md-4 col-xs-12 mt25 change-card" v-else>
        <button-full class="button-change-card" @click.native="openRegisterLink">
          {{ isUserInvited ? $t('Connect iPay') : $t('Add another card') }}
        </button-full>
      </div>
    </template>
    <template v-else>
      <bounce-loader style="margin-bottom: 40px" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CreditCard from '../../../../../../../modules/ipay-payment/components/CreditCard'
import ButtonFull from '../../../../theme/ButtonFull'
import BounceLoader from 'theme/components/theme/blocks/Home/Preloaders/BounceLoader'

export default {
  name: 'DefaultCreditCard',
  components: {
    ButtonFull,
    CreditCard,
    BounceLoader
  },
  data () {
    return {
      ipayLoading: false
    }
  },
  props: {
    location: {
      type: Object,
      required: true
    }
  },
  async beforeMount () {
    if (!this.getUserStatus) {
      this.ipayLoading = true
      await this.loadUserStatus({
        customerId: this.getCustomerId,
        phoneNumber: this.getPhoneNumber(true)
      })
        .then(() => this.loadIPayActionLink({
          customerId: this.getCustomerId,
          phoneNumber: this.getPhoneNumber(true),
          lang: 'ua',
          successUrl: this.successUrl
        }))
        .then(async res => {
          if (this.isUserExists) {
            await this.loadCards({
              customerId: this.getCustomerId,
              phoneNumber: this.getPhoneNumber(true)
            })
              .then(res => {
                if (this.defaultCard) {
                  this.$bus.$emit('ipay-card-selected', this.defaultCard.name)
                } else if (res.find(c => c.is_default)) {
                  this.$bus.$emit('ipay-card-selected', res.find(c => c.is_default).name)
                }
              })
          }
          return res
        })
        .finally(() => {
          this.ipayLoading = false
        })
    }
  },
  computed: {
    ...mapGetters({
      isUserExists: 'ipay-payment-user/isUserExist',
      isUserInvited: 'ipay-payment-user/isUserInvited',
      defaultCard: 'ipay-payment-user/getDefaultCreditCard',
      getPersonalDetails: 'checkout/getPersonalDetails',
      registerLinkLoading: 'ipay-payment-user/isRegisterLinkLoading',
      getPhoneNumber: 'user/getPhoneNumber',
      getUserStatus: 'ipay-payment-user/getUserStatus'
    }),
    checkoutPhone () {
      return this.getPersonalDetails ? this.getPersonalDetails.phoneNumber : ''
    },
    getCustomerId () {
      return this.$store.state.user.current.id
    },
    successUrl () {
      return window ? window.location.href : `/checkout/${this.currentLocation.code}`
    }
  },
  methods: {
    ...mapActions({
      loadCards: 'ipay-payment-user/getCardsList',
      loadUserStatus: 'ipay-payment-user/getUserStatus',
      getRegisterLink: 'ipay-payment-user/getRegisterLink',
      getInviteLink: 'ipay-payment-user/getInviteLink',
      loadIPayActionLink: 'ipay-payment-user/loadIPayActionLink',
      openRegisterLink: 'ipay-payment-user/openIPayActionLink'
    }),
    changeCard () {
      this.$bus.$emit('modal-show', 'credit-cards-list')
    }
  },
  watch: {
    defaultCard: function () {
      this.$bus.$emit('ipay-card-selected', this.defaultCard ? this.defaultCard.name : null)
    },
    'getPersonalDetails.phoneNumber': async function () {
      if (!this.getUserStatus || this.getUserStatus === 'invalid msisdn') {
        this.ipayLoading = true
        await this.loadUserStatus({
          customerId: this.getCustomerId,
          phoneNumber: this.getPhoneNumber(true)
        })
          .then(() => this.loadIPayActionLink({
            customerId: this.getCustomerId,
            phoneNumber: this.getPhoneNumber(true),
            lang: 'ua',
            successUrl: this.successUrl
          }))
          .then(async res => {
            if (this.isUserExists) {
              await this.loadCards({
                customerId: this.getCustomerId,
                phoneNumber: this.getPhoneNumber(true)
              })
                .then(res => {
                  if (this.defaultCard) {
                    this.$bus.$emit('ipay-card-selected', this.defaultCard.name)
                  } else if (res.find(c => c.is_default)) {
                    this.$bus.$emit('ipay-card-selected', res.find(c => c.is_default).name)
                  }
                })
            }
            return res
          })
          .finally(() => {
            this.ipayLoading = false
          })
      }
    }
  },
  beforeDestroy () {
    this.$bus.$emit('ipay-card-selected', null)
  }
}
</script>

<style lang="scss" scoped>
.credit-card {
  border: 1px #dedad7 solid;
  border-radius: 5px;
}
.button-change-card.change {
  width: auto;
  min-width: 100px;
  padding: 10px 0 !important;

  color: #11bb2e !important;
  font-size: 16px !important;
  font-weight: 400 !important;

  background: none !important;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
.col-md-6 {
  @media (max-width: 992px) and (min-width: 769px){
    flex-basis: 70%;
    max-width: 70%;
  }
}
.user-image {
  margin-top: 3px;
}
.user-full-name {
  margin-left: 5px;
  align-self: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: 0.09px;
  color: #111111;
}
.number-cart {
  text-align: center;
  background-color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 2.71px;
  color: #111111;
}
.underline {
  text-decoration: underline;
}
</style>
